<div class="data-item__content">
  <div [ngClass]="{'data-item__content-wrapper': flex}" #wrapper>
    <ng-content></ng-content>
  </div>
</div>
<div *ngIf="sourceValid" class="data-item__source">
  <span class="data-item__source-label" *ngIf="!compact && showLabel">Source:</span>
  <app-source class="data-item__source-value" [source]="source" [compact]="compact"></app-source>
</div>
